import { render, staticRenderFns } from "./CoveringWidget.vue?vue&type=template&id=de7b31d2&scoped=true&"
import script from "./CoveringWidget.vue?vue&type=script&lang=js&"
export * from "./CoveringWidget.vue?vue&type=script&lang=js&"
import style0 from "./CoveringWidget.vue?vue&type=style&index=0&id=de7b31d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b31d2",
  null
  
)

export default component.exports